import { Button, FormControlLabel, IconButton, Radio, RadioGroup, Tab, Tabs } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import { PictureAsPdfOutlined } from '@material-ui/icons';
import InfoIcon from '@mui/icons-material/Info';
import { FormControl } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import axios from 'axios';
import MuiPhoneNumber from 'material-ui-phone-number';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Countries } from '../../../../../constants/Countries';
import { ASSET_TYPE_DOC, ASSET_TYPE_PROPERTY } from '../../../../../constants/PropertyConst';
import {
  ALL_DAY,
  CONTACT_INFO_TYPES,
  RESTAURANT_FILTER,
  RESTAURANT_TYPES,
  TYPE_LIST,
  REDIRECT_OPTIONS,
} from '../../../../../constants/restaurantConst';
import ContactInformation from '../../../../../shared/contact-information/ContactInformation';
import CustomHours from '../../../../../shared/custom-hours/Custom-Hours';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import CustomMultiSelect from '../../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomUpload from '../../../../../shared/form-controls/custom-upload/Custom-Upload';
import LocationInput from '../../../../../shared/google-location-input/LocationInput';
import LocationMap from '../../../../../shared/google-map/LocationMap';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import { parseObj } from '../../../../../utils/commonUtils';
import {
  decodeMediaKeyValue,
  renderVideos,
  renderGifs,
  toMediaContent,
  processGifsForUpload,
} from '../../../../../utils/mediaUtils';
import {
  formDataValidate,
  handleValidation,
  validateAlphanumeric,
} from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  createRestaurant,
  getPreSignedUrl,
  updateRestaurantDetails,
} from '../../../../../utils/PropertyAPIUtils';
import { allHotelsSelector, fetchAllRestaurant } from '../../../../property/propertySlice';
import FooterButton from '../../FooterButton';
import './info-create.scss';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';
import { MAX_PDF_SIZE } from '../../../../../utils/Constants';
import { ASSET_URL } from '../../../../../env/Configurations';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const InfoCreate = (props) => {
  const { toggleDrawer, restaurant, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [days, setDays] = useState();
  const [customTime, setCustomTime] = useState([]);
  const [customTimeError, setCustomTimeError] = useState({
    status: false,
    message: '',
  });
  const [contactInfoList, setContactInfoList] = useState([]);
  const originalHotels = useSelector(allHotelsSelector);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [rawVideos, setRawVideos] = useState([]);
  const [rawGifs, setRawGifs] = useState([]);
  const [videoImageUrl, setVideoImageUrl] = useState('');
  const [gifImageUrl, setGifImageUrl] = useState('');
  const [hasVideoError, setHasVideoError] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGifLoading, setIsGifLoading] = useState(false);
  const [additionalMenus, setAdditionalMenus] = useState([]);
  const [menuDocType, setMenuDocType] = useState('S3');

  const groupId = originalHotels?.find((hotel) => hotel?.id === hotelId)?.groupId;

  //info : when Backend API is ready then we use this code
  // const originalPrimaryCuisines = useSelector(selectPrimaryCuisineDetails);
  // const originalSecondaryCuisines = useSelector(selectSecondaryCuisineDetails);

  // const [primaryCuisineOptions, setPrimaryCuisineOptions] = useState(
  //   originalPrimaryCuisines
  // );
  // const [secondaryCuisineOptions, setSecondaryCuisineOptions] = useState(
  //   originalSecondaryCuisines
  // );

  const [countryCode, setCountryCode] = useState('');
  const [formData, setFormData] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      name: {
        value: '',
        fieldName: 'Name',
        errors: {},
        validations: ['required', 'maxLength'],
        maxLength: 100,
        tab: 0,
      },
      code: {
        value: '',
        fieldName: 'Code',
        errors: {},
        validations: ['required', 'validAlphaNumeric'],
        tab: 0,
      },
      venueGroupId: {
        value: '',
        fieldName: 'Venue Group Id',
        errors: {},
        validations: [],
        tab: 0,
      },
      awards: {
        value: '',
        fieldName: 'Awards',
        errors: {},
        validations: [],
        tab: 0,
      },
      primaryCuisine: {
        value: '',
        fieldName: 'Primary Cuisine',
        errors: {},
        validations: ['maxLength'],
        maxLength: 30,
        tab: 0,
      },
      secondaryCuisine: {
        value: [],
        fieldName: 'Secondary Cuisine',
        errors: {},
        validations: ['maxLength'],
        maxLength: 31,
        tab: 0,
      },
      type: {
        value: '',
        fieldName: 'Type',
        errors: {},
        validations: ['required'],
        tab: 0,
      },
      isActive: {
        value: false,
        fieldName: 'Active',
        errors: {},
        validations: [],
        tab: 0,
      },
      description: {
        value: '',
        fieldName: 'Description',
        errors: {},
        validations: ['required'],
        tab: 0,
      },
      additionalInformation: {
        value: '',
        fieldName: 'Additional Information',
        errors: {},
        validations: ['maxLength'],
        maxLength: 1000,
        tab: 0,
      },
      menu: {
        value: { url: '', type: '', name: '' },
        fieldName: 'Menu',
        errors: {},
        validations: ['validIfUrl', 'safeURL', 'safeDomain'],
        tab: 0,
      },
      customAttributes: {
        value: [],
        fieldName: 'Custom Attributes',
        errors: {},
        validations: [],
        tab: 0,
      },
      availableOn: {
        value: 'everyDay',
        fieldName: 'availableOn',
        errors: {},
        validations: [],
        tab: 1,
      },
      days: {
        value: [],
        fieldName: 'days',
        errors: {},
        validations: [],
        tab: 1,
      },
      hours: {
        value: 'allTime',
        fieldName: 'Hours',
        errors: {},
        validations: [],
        tab: 1,
      },
      from: {
        value: '11:00',
        fieldName: 'Hours From',
        errors: {},
        validations: ['required', 'validTime'],
        tab: 1,
      },
      to: {
        value: '23:00',
        fieldName: 'Hours To',
        errors: {},
        validations: ['required', 'validTime'],
        tab: 1,
      },
      email: {
        value: '',
        fieldName: 'Email Id',
        errors: {},
        validations: ['validEmail'],
        tab: 2,
      },
      phoneNumber: {
        value: '',
        fieldName: 'Phone Number',
        errors: {},
        validations: [],
        maxLimit: 10,
        tab: 2,
      },
      addressLine1: {
        value: '',
        fieldName: 'Address Line 1',
        errors: {},
        validations: ['required'],
        tab: 3,
      },
      addressLine2: {
        value: '',
        fieldName: 'Address Line 2',
        errors: {},
        validations: [],
        tab: 3,
      },
      country: {
        value: '',
        fieldName: 'Country',
        errors: {},
        validations: ['required'],
        tab: 3,
      },
      state: {
        value: '',
        fieldName: 'State',
        errors: {},
        validations: [],
        tab: 3,
      },
      postalCode: {
        value: '',
        fieldName: 'Postal Code',
        errors: {},
        validations: [],
        tab: 3,
      },
      city: {
        value: '',
        fieldName: 'City',
        errors: {},
        validations: ['required'],
        tab: 3,
      },
      latitude: {
        value: '',
        fieldName: 'Latitude',
        errors: {},
        validations: [],
        tab: 3,
      },
      longitude: {
        value: '',
        fieldName: 'Longitude',
        errors: {},
        validations: [],
        tab: 3,
      },
      area: {
        value: '',
        fieldName: 'Area (Ex: DownTown Avenue)',
        errors: {},
        validations: [],
        placeholder: '(Ex: DownTown Avenue)',
        tab: 3,
      },
      timeZone: {
        value: '',
        fieldName: 'Time Zone',
        errors: {},
        validations: ['required'],
        tab: 3,
      },
      images: {
        value: [],
        fieldName: 'Images',
        errors: {},
        validations: [],
        tab: 5,
      },
      menuStatus: {
        value: 'Inactive',
        fieldName: 'Menu Status',
        validations: [],
        tab: 0,
      },

      ctaTitle: {
        value: '',
        fieldName: 'CTA Title',
        errors: {},
        validations: ['maxLength'],
        maxLength: 30,
        tab: 0,
      },
      status: {
        value: 'Inactive',
        fieldName: 'CTA Status',
        validations: [],
        tab: 4,
      },
      ctaTabTitle: {
        value: '',
        fieldName: 'CTA Title',
        errors: {},
        validations: ['required', 'maxLength'],
        maxLength: 30,
        tab: 4,
      },
      redirectOption: {
        value: '',
        fieldName: 'Redirect Option',
        errors: {},
        validations: ['required'],
        tab: 4,
      },
      redirectUrl: {
        value: '',
        fieldName: 'URL',
        placeholder: 'Please paste the redirect URL here',
        errors: {},
        validations: ['required', 'validUrl', 'safeURL', 'safeDomain'],
        tab: 4,
      },
      videos: {
        value: [],
        fieldName: 'Videos',
        errors: {},
        validations: [],
        tab: 5,
      },
      gifs: {
        value: [],
        fieldName: 'GIFs',
        errors: {},
        validations: [],
        tab: 5,
      },
    },
  );

  const [primaryCuisineOptions, setPrimaryCuisineOptions] = useState(RESTAURANT_FILTER[1].subMenu);
  const [secondaryCuisineOptions, setSecondaryCuisineOptions] = useState(
    RESTAURANT_FILTER[1].subMenu,
  );

  useEffect(() => {
    if (restaurant) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = restaurant[field];
      }
      const isEveryDay = restaurant.hours.find((r) => r.day === 'EVERYDAY');
      currFields.availableOn.value = !isEveryDay ? 'everyDay' : 'custom';
      currFields.hours.value = !isEveryDay ? 'allTime' : 'custom';
      if (restaurant.hours.length > 0) {
        currFields.availableOn.value = isEveryDay ? 'everyDay' : 'custom';
        currFields.hours.value =
          (isEveryDay?.open && isEveryDay?.close) === ALL_DAY ? 'allTime' : 'custom';
        const daysToMap = formatArrayForDisplay(restaurant.hours);
        setCustomTime(daysToMap);
      }
      const startDate = new Date();
      currFields.from.value = formattedTime(startDate);
      const endDate = startDate.setHours(startDate.getHours() + 1);
      currFields.to.value = formattedTime(new Date(endDate));
      currFields.email.value = restaurant.email;
      currFields.phoneNumber.value = restaurant.contactNumber;
      if (restaurant.contact && restaurant.contact.length > 0) {
        let riInfo = [];
        riInfo = restaurant?.contact?.map((val, ndx) => {
          return { ...val };
        });
        setContactInfoList(riInfo);
      }
      currFields.addressLine1.value = restaurant.location.addressLine1;
      currFields.addressLine2.value = restaurant.location.addressLine2;
      currFields.country.value = restaurant.location.country;
      currFields.state.value = restaurant.location.state;
      currFields.postalCode.value = restaurant.location.postalCode;
      currFields.city.value = restaurant.location.city;
      currFields.area.value = restaurant.location.area;
      currFields.latitude.value = restaurant.location.latitude;
      currFields.longitude.value = restaurant.location.longitude;
      currFields.timeZone.value = restaurant.location.timeZone;
      const { Video: videoMediaContent, GIF: gifMediaContent } = decodeMediaKeyValue(
        restaurant.mediaContent,
      );
      const videoData = videoMediaContent || restaurant.videos || {};
      const gifData = gifMediaContent || restaurant.gifs || {};

      setVideoImageUrl(videoData.imageUrl || '');
      setGifImageUrl(gifData.imageUrl || '');

      setRawVideos(renderVideos(videoData));
      setRawGifs(renderGifs(gifData));

      currFields.secondaryCuisine.value = restaurant.secondaryCuisine || [];
      currFields.customAttributes.value = restaurant.customAttributes || [];
      currFields.ctaTabTitle.value = restaurant.cta.ctaTitle;
      currFields.redirectOption.value = restaurant.cta.redirectOption;
      currFields.redirectUrl.value = restaurant.cta.redirectUrl;
      currFields.status.value = restaurant.cta.status;
      let { url, type, name } = parseObj(restaurant.menu);
      formData.menu.value = { url: url, type: type, name: name };
      setMenuDocType(type || 'S3');
      if (restaurant.additionalMenu && restaurant.additionalMenu.length > 0) {
        setAdditionalMenus(
          restaurant.additionalMenu.map((m, i) => ({
            id: Date.now() + i,
            docType: m.menuType || 'S3',
            ctaTitle: {
              value: m.ctaTitle || '',
              fieldName: 'CTA Title',
              errors: {},
              validations: ['required', 'maxLength'],
              maxLength: 30,
              tab: 0,
            },
            menu: {
              value: (() => {
                const parsed = typeof m.menu === 'string' && m.menu.includes('=') ? parseObj(m.menu) : null;
                return parsed?.url
                  ? { url: parsed.url, type: parsed.type || m.menuType || '', name: parsed.name || '' }
                  : { url: m.menu || '', type: m.menuType || '', name: m.menuType === 'S3' && m.menu ? 'Menu.pdf' : '' };
              })(),
              fieldName: 'Menu',
              errors: {},
              validations: ['validIfUrl', 'safeURL'],
              tab: 0,
            },
          })),
        );
      }
      setFormData(currFields);
    }
  }, [restaurant, setFormData]);

  const formattedTime = (time) => {
    return time.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };

  const formatArrayForDisplay = (selectedDay) => {
    const daysToReturn = [];
    let daysList = [...selectedDay];
    while (daysList.length > 0) {
      const firstObject = daysList[0];
      const filteredRows = daysList.filter(
        (dayKey) => dayKey.open === firstObject.open && dayKey.close === firstObject.close,
      );
      daysToReturn.push({
        days: filteredRows.map(
          (filteredRowDaysName) =>
            `${filteredRowDaysName.day.charAt(0).toUpperCase()}${filteredRowDaysName.day
              .slice(1)
              .toLowerCase()}`,
        ),
        from: filteredRows[0].open,
        to: filteredRows[0].close,
      });
      const tempDaysList = [...daysList];
      filteredRows.forEach((filteredRowsItem) => {
        const findFilteredDayIndex = tempDaysList.findIndex(
          (tempDaysListItem) => tempDaysListItem.day === filteredRowsItem.day,
        );
        tempDaysList.splice(findFilteredDayIndex, 1);
      });
      daysList = [...tempDaysList];
    }
    return daysToReturn;
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    // If tabValue is given, filter out the form fields in current tab
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };


  const handleSubmit = async (e) => {
    try {
      const lang = decryptLocalStorage('lang');
      const language = lang !== 'en' ? lang : '';
      e.preventDefault();
      const isAdditionalMenusValid = validateAdditionalMenus();
      if (!validate(0) || !isAdditionalMenusValid || !validate(2) || !validate(3) || !validate(4)) {
        if (!validate(0) || !isAdditionalMenusValid) setTabValue(0);
        else if (!validate(2)) setTabValue(2);
        else if (!validate(3)) setTabValue(3);
        else if (!validate(4)) setTabValue(4);
        notificationManager('danger', 'Enter all required fields');
        return false;
      }
      dispatch(stepUpLoaderCount());
      toggleDrawer('', false, '');
      setLoading(true);
      let selectedDay = [];
      for (let time of customTime) {
        if (time?.days && time?.days?.length > 0) {
          for (let day of time.days) {
            selectedDay?.push({
              day: day?.toUpperCase(),
              open: time?.from,
              close: time?.to,
            });
          }
        }
      }

      const images = await getProcessedImages(
        rawImages,
        originalHotels?.find((hotel) => hotel?.id === hotelId)?.groupId,
        RESTAURANT_TYPES,
        hotelId,
      );

      const gifData = await processGifsForUpload({
        rawGifs,
        groupId,
        propertyType: RESTAURANT_TYPES,
        hotelId,
      });

      const mediaContent = toMediaContent({
        videoList: rawVideos,
        videoImageUrl,
        gifList: gifData,
        gifImageUrl,
      });

      const payload = {
        code: formData.code.value,
        name: formData.name.value,
        venueGroupId: formData.venueGroupId.value,
        awards: formData.awards.value,
        primaryCuisine: formData.primaryCuisine.value,
        secondaryCuisine: formData.secondaryCuisine.value,
        type: formData.type.value,
        description: formData.description.value,
        additionalInformation: formData.additionalInformation.value,
        menu: formData.menuStatus.value === 'Active' ? formData.menu.value : { url: '', type: '', name: '' },
        ctaTitle: formData.menuStatus.value === 'Active' ? formData.ctaTitle.value : '',
        additionalMenu: formData.menuStatus.value === 'Active'
          ? additionalMenus.map((m) => ({
              ctaTitle: m.ctaTitle.value,
              menuType: m.menu.value.type || 'S3',
              menu: m.menu.value,
            }))
          : [],
        customAttributes: formData.customAttributes.value,
        hours: selectedDay,
        email: formData.email.value,
        contactNumber: formData.phoneNumber.value,
        contact: contactInfoList,
        location: {
          addressLine1: formData.addressLine1.value,
          addressLine2: formData.addressLine2.value,
          country: formData.country.value,
          state: formData.state.value,
          city: formData.city.value,
          area: formData.area.value,
          postalCode: formData.postalCode.value,
          latitude: formData.latitude.value,
          longitude: formData.longitude.value,
          timeZone: formData.timeZone.value,
        },
        menuStatus: formData.menuStatus.value,
        ctaTitle: formData.menuStatus.value === 'Active' ? formData.ctaTitle.value : '',
        cta: {
          ctaTitle: formData.ctaTabTitle.value,
          redirectOption: formData.redirectOption.value,
          redirectUrl: formData.redirectUrl.value,
          status: formData.status.value,
        },
        images,
        mediaContent,
        hotelId,
        isActive: formData.isActive.value,
        cuisine: '',
      };
      if (restaurant?.id) {
        payload.id = restaurant.id;
        await updateRestaurantDetails(payload, language);
        notificationManager('success', 'Restaurant updated successfully');
      } else {
        await createRestaurant(payload, language);
        notificationManager('success', 'Restaurant created successfully');
      }
      dispatch(fetchAllRestaurant(hotelId));
      setLoading(false);
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors
          ? error?.graphQLErrors?.[0]?.message
          : 'Error occurred while creating the Restaurant',
      );
      setLoading(false);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onLocationSelect = async (locObj) => {
    let addressLine1 = '';
    let addressLine2 = '';
    let country = '';
    let state = '';
    let postalCode = '';
    let city = '';
    const latitude = locObj.geometry.location.lat();
    const longitude = locObj.geometry.location.lng();
    let timeZone = '';
    const currFormData = { ...formData };

    locObj.address_components.forEach((item) => {
      if (item.types.includes('street_number')) {
        addressLine1 = item.long_name;
        return;
      }

      if (item.types.includes('route')) {
        addressLine1 += ` ${item.long_name}`;
        return;
      }

      if (item.types.includes('neighborhood') && item.types.includes('political')) {
        addressLine2 = item.long_name;
        return;
      }

      if (item.types.includes('country') && item.types.includes('political')) {
        country = item.long_name;
        return;
      }

      if (item.types.includes('administrative_area_level_1') && item.types.includes('political')) {
        state = item.long_name;
        return;
      }

      if (item.types.includes('postal_code')) {
        postalCode = item.long_name;
        return;
      }

      if (item.types.includes('locality') && item.types.includes('political')) {
        city = item.long_name;
      }
    });

    try {
      const timeInSecs = new Date().getTime() / 1000;
      const res = await axios.get(
        `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude}%2C${longitude}&timestamp=${timeInSecs}&key=AIzaSyAa_UAQQDPYFCyHvbDG4rlkxFYk1vgLFkM`,
      );

      if (res.data && res.data.status === 'OK' && res.data.timeZoneName) {
        timeZone = res.data.timeZoneName;
      }
    } catch (err) {
      console.error(err);
    }

    currFormData.addressLine1.value = addressLine1 || locObj.vicinity;
    currFormData.addressLine2.value = addressLine2;
    currFormData.country.value = country;
    currFormData.state.value = state;
    currFormData.postalCode.value = postalCode;
    currFormData.city.value = city;
    currFormData.latitude.value = latitude;
    currFormData.longitude.value = longitude;
    currFormData.timeZone.value = timeZone;
    setFormData(currFormData);
    validate(3);
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
      setIsTabInValid(false);
      return;
    }

    let isValidTab = false;
    for (let tab = tabValue; tab < newValue; tab++) {
      isValidTab = !validate(tab);
      if (isValidTab) {
        setTabValue(tab);
        return;
      }
    }

    if (validate(tabValue)) {
      if (tabValue === 0 && formData?.menuStatus?.value !== 'Inactive') {
        if (formData?.menu?.value?.url?.length === 0) return;
        if (additionalMenus.some((m) => !m.ctaTitle.value || !m.menu.value.url)) return;
      }
      setTabValue(newValue);
    }
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const isHoursTabWithoutTimings = tabValue === 1 && (!customTime || customTime.length === 0);

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images];
    images.splice(index, 1);
    setFormData({ images });
  };

  const handlePhoneNoChange = (phone, country) => {
    setCountryCode(country?.countryCode);
    const currField = { ...formData }.phoneNumber;
    if (phone.startsWith(`+${country.dialCode}`) && phone.length === country.dialCode.length + 1) {
      currField.value = '';
    } else {
      currField.value = phone;
    }

    setFormData({ ...formData, phoneNumber: currField });
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
    if (
      tabValue === 0 &&
      formData.menu.value.url === '' &&
      formData.menuStatus.value === 'Active'
    ) {
      setIsTabInValid(true);
    }
    if (
      tabValue === 0 &&
      formData.menuStatus.value === 'Active' &&
      additionalMenus.some((m) => !m.ctaTitle.value || !m.menu.value.url)
    ) {
      setIsTabInValid(true);
    }
    if (
      tabValue === 2 &&
      !currTabFromData.email?.errors?.required &&
      !currTabFromData.email?.errors?.validEmail &&
      formData.phoneNumber.value !== ''
    ) {
      setIsTabInValid(formData.phoneNumber.value.length < 10);
    }
  }, [formData, additionalMenus]);

  const onChangePostalCode = (e) => {
    if (e.value) {
      const isValid = validateAlphanumeric(e.value);
      if (!isValid) return false;
    }
    setFormData({ postalCode: e });
  };

  const onMenuStatusChange = (e) => {
    const newStatus = e.target.value;
    const menuStatus = {
      value: newStatus,
      fieldName: 'Menu Status',
      validations: [],
      tab: 0,
    };
    if (newStatus === 'Inactive') {
      setFormData({
        menuStatus,
        ctaTitle: { ...formData.ctaTitle, value: '', errors: {} },
        menu: { ...formData.menu, value: { url: '', type: '', name: '' }, errors: {} },
      });
      setMenuDocType('S3');
      setAdditionalMenus([]);
    } else {
      setFormData({ menuStatus });
    }
  };

  const addAdditionalMenu = () => {
    setAdditionalMenus((prev) => [
      ...prev,
      {
        id: Date.now(),
        docType: 'S3',
        ctaTitle: {
          value: '',
          fieldName: 'CTA Title',
          errors: {},
          validations: ['required', 'maxLength'],
          maxLength: 30,
          tab: 0,
        },
        menu: {
          value: { url: '', type: '', name: '' },
          fieldName: 'Menu',
          errors: {},
          validations: ['validIfUrl', 'safeURL'],
          tab: 0,
        },
      },
    ]);
  };

  const onMainMenuDocTypeChange = (e) => {
    const newType = e.target.value;
    setMenuDocType(newType);
    const resetMenu = { ...formData.menu };
    resetMenu.value = { url: '', type: newType, name: '' };
    resetMenu.errors = {};
    setFormData({ menu: resetMenu });
  };

  const updateAdditionalMenuDocType = (id, newType) => {
    setAdditionalMenus((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              docType: newType,
              menu: {
                ...item.menu,
                value: { url: '', type: newType, name: '' },
                errors: {},
              },
            }
          : item,
      ),
    );
  };

  const removeAdditionalMenu = (id) => {
    setAdditionalMenus((prev) => prev.filter((item) => item.id !== id));
  };

  const updateAdditionalMenuCtaTitle = (id, field) => {
    setAdditionalMenus((prev) =>
      prev.map((item) => (item.id === id ? { ...item, ctaTitle: field } : item)),
    );
  };

  const updateAdditionalMenuFile = (id, field) => {
    setAdditionalMenus((prev) =>
      prev.map((item) => (item.id === id ? { ...item, menu: field } : item)),
    );
  };

  const validateAdditionalMenus = () => {
    if (formData?.menuStatus?.value !== 'Active' || additionalMenus.length === 0) return true;
    let isValid = true;
    const updatedMenus = additionalMenus.map((menuItem) => {
      const updatedCtaTitle = { ...menuItem.ctaTitle };
      handleValidation(updatedCtaTitle);
      if (Object.keys(updatedCtaTitle.errors).some((key) => updatedCtaTitle.errors[key])) {
        isValid = false;
      }
      if (!menuItem.menu.value.url) isValid = false;
      return { ...menuItem, ctaTitle: updatedCtaTitle };
    });
    setAdditionalMenus(updatedMenus);
    return isValid;
  };

  useEffect(() => {
    const ctaTitle =
      formData?.menuStatus?.value === 'Inactive'
        ? { ...formData.ctaTitle, validations: [] }
        : { ...formData.ctaTitle, validations: ['required'] };

    setFormData({ ctaTitle });
  }, [formData?.menuStatus?.value]);

  const onCtaStatusChange = (e) => {
    const status = {
      value: e.target.value,
      fieldName: 'CTA Status',
      validations: [],
      tab: 4,
    };
    setFormData({ status });
    if (e.target.value === 'Inactive') {
      formData.ctaTabTitle.value = '';
      formData.redirectOption.value = '';
      formData.redirectUrl.value = '';
    }
  };

  useEffect(() => {
    const ctaTabTitle =
      formData.status.value === 'Inactive'
        ? { ...formData.ctaTabTitle, validations: [] }
        : { ...formData.ctaTabTitle, validations: ['required', 'maxLength'] };

    setFormData({ ctaTabTitle });
  }, [formData.status.value]);

  useEffect(() => {
    const redirectOption =
      formData.status.value === 'Inactive'
        ? { ...formData.redirectOption, validations: [] }
        : { ...formData.redirectOption, validations: ['required'] };

    setFormData({ redirectOption });
  }, [formData.status.value]);

  useEffect(() => {
    const redirectUrl =
      formData.status.value === 'Inactive'
        ? { ...formData.redirectUrl, validations: [] }
        : {
            ...formData.redirectUrl,
            validations: ['required', 'validUrl', 'safeURL', 'safeDomain'],
          };

    setFormData({ redirectUrl });
  }, [formData.status.value]);

  useEffect(() => {
    const redirectUrl =
      formData.redirectOption.value === 'External URL'
        ? {
            ...formData.redirectUrl,
            validations: ['required', 'validUrl', 'safeURL', 'safeDomain'],
          }
        : { ...formData.redirectUrl, validations: [] };

    setFormData({ redirectUrl });
  }, [formData.redirectOption.value]);

  useEffect(() => {
    if (formData.redirectOption.value === 'Restaurant Booking Flow') {
      const redirectUrl = {
        value: '',
        fieldName: 'URL',
        placeholder: 'Please paste the redirect URL here',
        errors: {},
        validations: [],
        maxLength: 1000,
        tab: 4,
      };
      setFormData({ redirectUrl });
    }
  }, [formData.redirectOption.value]);

  useEffect(() => {
    if (formData.primaryCuisine.value) {
      const updatedSecondaryCuisineOptions = RESTAURANT_FILTER[1].subMenu.filter(
        (item) => item.name !== formData.primaryCuisine.value,
      );
      setSecondaryCuisineOptions(updatedSecondaryCuisineOptions);
    } else {
      setSecondaryCuisineOptions(RESTAURANT_FILTER[1].subMenu);
    }
  }, [formData.primaryCuisine]);

  ////info : when Backend API is ready then we use this code
  // useEffect(() => {
  //   const primaryCuisineValue = formData?.primaryCuisine?.value || [];
  //   const updatedSecondaryCuisineOptions = primaryCuisineValue
  //     ? originalSecondaryCuisines?.filter(
  //         (sCuisine) => sCuisine?.name !== primaryCuisineValue
  //       )
  //     : originalSecondaryCuisines;

  //   setSecondaryCuisineOptions(updatedSecondaryCuisineOptions);
  // }, [formData?.primaryCuisine?.value, originalSecondaryCuisines]);

  // useEffect(() => {
  //   const secondaryCuisineNames = formData?.secondaryCuisine?.value || [];
  //   const updatedPrimaryCuisineOptions = secondaryCuisineNames?.length
  //     ? originalPrimaryCuisines?.filter(
  //         (pCuisine) => !secondaryCuisineNames.includes(pCuisine?.name)
  //       )
  //     : originalPrimaryCuisines;

  //   setPrimaryCuisineOptions(updatedPrimaryCuisineOptions);
  // }, [formData?.secondaryCuisine, originalPrimaryCuisines]);

  useEffect(() => {
    if (formData?.primaryCuisine?.value) {
      const updatedSecondaryCuisineOptions = RESTAURANT_FILTER[1]?.subMenu.filter(
        (item) => item?.name !== formData?.primaryCuisine?.value,
      );
      setSecondaryCuisineOptions(updatedSecondaryCuisineOptions);
    } else {
      setSecondaryCuisineOptions(RESTAURANT_FILTER[1]?.subMenu);
    }
  }, [formData?.primaryCuisine]);

  useEffect(() => {
    if (formData?.secondaryCuisine?.value?.length > 0) {
      const updatedPrimaryCuisineOptions = RESTAURANT_FILTER[1]?.subMenu.filter(
        (item) => !formData?.secondaryCuisine?.value?.includes(item?.name),
      );
      setPrimaryCuisineOptions(updatedPrimaryCuisineOptions);
    } else {
      setPrimaryCuisineOptions(RESTAURANT_FILTER[1]?.subMenu);
    }
  }, [formData?.secondaryCuisine]);

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-3'>
            <span className='page-title'>{restaurant ? 'Edit Restaurant' : 'Add Restaurant'}</span>
          </div>
          <div className='col-md-8'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='hotel-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Hours' />
              <Tab label='Contact' />
              <Tab label='Location' />
              <Tab label='CTA' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Hotel Details</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.code}
                    handleInputChange={(e) => {
                      setFormData({ code: e });
                    }}
                    maxLength={8}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>

                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.type}
                    handleInputChange={(e) => {
                      setFormData({ type: e });
                      if (e.value === 'bar') {
                        formData.primaryCuisine.value = '';
                        formData.secondaryCuisine.value = [];
                      }
                    }}
                    labelField='name'
                    valueField='value'
                    options={TYPE_LIST}
                    hideNullOption={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.awards}
                    handleInputChange={(e) => {
                      setFormData({ awards: e });
                    }}
                  />
                </div>
              </div>
              {/** @info : when Backend API is ready then we use this code */}
              {/* <div className="row">
                <div className="col-md-6 mb-3">
                  {(formData?.type.value === "restaurant" ||
                    formData?.type.value === "") && (
                    <CustomSelect
                      item={formData.primaryCuisine}
                      handleInputChange={(e) => {
                        setFormData({ primaryCuisine: e });
                      }}
                      labelField="name"
                      valueField="id"
                      options={primaryCuisineOptions}
                    />
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  {(formData?.type.value === "restaurant" ||
                    formData?.type.value === "") && (
                    <CustomMultiSelect
                      item={formData.secondaryCuisine}
                      options={secondaryCuisineOptions}
                      hideNullOption={true}
                      handleInputChange={(e) => {
                        setFormData({ secondaryCuisine: e });
                      }}
                      valueField="id"
                    />
                  )}
                </div>
              </div> */}
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData?.primaryCuisine}
                    handleInputChange={(e) => {
                      setFormData({
                        primaryCuisine: e,
                      });
                    }}
                    labelField='name'
                    valueField='id'
                    options={primaryCuisineOptions}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomMultiSelect
                    item={formData?.secondaryCuisine}
                    options={secondaryCuisineOptions}
                    hideNullOption={true}
                    handleInputChange={(e) => {
                      setFormData({
                        secondaryCuisine: e,
                      });
                    }}
                    valueField='id'
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.venueGroupId}
                    handleInputChange={(e) => {
                      setFormData({ venueGroupId: e });
                    }}
                  />
                </div>
                <div className='col-md-3 mb-3'>
                  <div className='d-flex align-items-center'>
                    <CustomCheckbox
                      item={formData.isActive}
                      handleInputChange={(e) => {
                        setFormData({ isActive: e });
                      }}
                      color='primary'
                    />
                    <CustomToolTip
                      title='Deactivating this, hides it from Guest app'
                      placement='right-end'
                    >
                      <InfoIcon style={{ marginLeft: 8 }} />
                    </CustomToolTip>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.description}
                    handleInputChange={(e) => {
                      setFormData({ description: e });
                    }}
                    maxLength='2000'
                    multiline={true}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.additionalInformation}
                    handleInputChange={(e) => {
                      setFormData({ additionalInformation: e });
                    }}
                    maxLength='1000'
                    multiline={true}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <h4 className='tab-title menu'>{formData.menu.fieldName}</h4>
              <div className='d-flex justify-content-between'>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby='demo-radio-buttons-group-label'
                    defaultValue={formData.menuStatus.value}
                    value={formData.menuStatus.value || 'Inactive'}
                    name='radio-buttons-group'
                    onChange={(e) => onMenuStatusChange(e)}
                  >
                    <div className='menu-active-status'>
                      <FormControlLabel
                        value='Active'
                        control={<Radio className='radio' />}
                        label='Active'
                        className='me-5'
                      />
                    </div>

                    <FormControlLabel value='Inactive' control={<Radio />} label='Inactive' />
                  </RadioGroup>
                </FormControl>
              </div>
              <div>
                {formData?.menuStatus?.value === 'Active' ? (
                  <div className='row'>
                    <div className='col-md-6 mb-3'>
                      <CustomTextField
                        item={formData.ctaTitle}
                        handleInputChange={(e) => {
                          setFormData({ ctaTitle: e });
                        }}
                        maxLength={30}
                        endAdornment={true}
                        characterCount={true}
                      />
                    </div>

                    <div className='col mt-4'>
                      <CustomToolTip title='Default button name : Menu' placement='right-end'>
                        <InfoIcon />
                      </CustomToolTip>
                    </div>

                    <RadioGroup
                      row
                      aria-label='menu-doc-type'
                      value={menuDocType}
                      onChange={onMainMenuDocTypeChange}
                      className='document-type mb-3'
                    >
                      <FormControlLabel
                        value='S3'
                        control={<Radio color='primary' />}
                        label='Upload PDF Document'
                        className='me-5'
                      />
                      <FormControlLabel
                        value='WEB_URL'
                        control={<Radio color='primary' />}
                        label='Paste URL'
                      />
                    </RadioGroup>
                    <CustomUpload
                      key={menuDocType}
                      item={formData.menu}
                      hotelId={hotelId}
                      showNotification={true}
                      radioDisable={true}
                      additionalInput={{
                        type: ASSET_TYPE_DOC,
                        groupId: groupId,
                        propertyType: RESTAURANT_TYPES,
                      }}
                      onUpload={(e) => {
                        setFormData({ menu: e });
                        if (e?.value?.type) setMenuDocType(e.value.type);
                      }}
                      webUrlPlaceholder='Paste URL'
                      maxFileSize={MAX_PDF_SIZE}
                    />
                  </div>
                ) : (
                  <div className='pb-3' />
                )}
              </div>
              {formData?.menuStatus?.value === 'Active' && (
                <div className={`additional-menu-section${additionalMenus.length > 0 ? ' has-items' : ''}`}>
                  <div className='additional-menu-heading'>
                    <h4 className='tab-title'>Additional Menus</h4>
                    <CustomToolTip
                      title='Use this section to create and manage additional menus.'
                      placement='right-end'
                    >
                      <InfoIcon style={{ marginLeft: 8 }} />
                    </CustomToolTip>
                  </div>
                  {additionalMenus.map((menuItem, index) => (
                    <div key={menuItem.id} className='additional-menu-item'>
                      <div className='row'>
                        <div className='col-md-6 mb-3'>
                          <CustomTextField
                            item={menuItem.ctaTitle}
                            handleInputChange={(e) =>
                              updateAdditionalMenuCtaTitle(menuItem.id, e)
                            }
                            maxLength={30}
                            endAdornment={true}
                            characterCount={true}
                          />
                        </div>
                      </div>
                      <div className='additional-menu-radio-row'>
                        <RadioGroup
                          row
                          aria-label={`additional-menu-doc-type-${menuItem.id}`}
                          value={menuItem.docType || 'S3'}
                          onChange={(e) => updateAdditionalMenuDocType(menuItem.id, e.target.value)}
                          className='document-type'
                        >
                          <FormControlLabel
                            value='S3'
                            control={<Radio color='primary' />}
                            label='Upload PDF Document'
                            className='me-5'
                          />
                          <FormControlLabel
                            value='WEB_URL'
                            control={<Radio color='primary' />}
                            label='Paste URL'
                          />
                        </RadioGroup>
                        <span
                          className='pointer remove-btn'
                          onClick={() => removeAdditionalMenu(menuItem.id)}
                        >
                          Remove
                        </span>
                      </div>
                      <CustomUpload
                        key={`${menuItem.id}-${menuItem.docType}`}
                        item={menuItem.menu}
                        hotelId={hotelId}
                        showNotification={true}
                        radioDisable={true}
                        additionalInput={{
                          type: ASSET_TYPE_DOC,
                          groupId: groupId,
                          propertyType: RESTAURANT_TYPES,
                        }}
                        onUpload={(e) => updateAdditionalMenuFile(menuItem.id, e)}
                        webUrlPlaceholder='Paste URL'
                        maxFileSize={MAX_PDF_SIZE}
                      />
                    </div>
                  ))}
                  <Button
                    variant='outlined'
                    color='primary'
                    onClick={addAdditionalMenu}
                  >
                    Add
                  </Button>
                </div>
              )}
              <KeyValuePairList
                item={formData.customAttributes}
                onListChange={(e) => {
                  setFormData({ customAttributes: e });
                }}
              />
            </div>
          )}
          {tabValue === 1 && (
            <div className='col-md-12 mb-3'>
              <CustomHours
                setFormData={setFormData}
                formData={formData}
                days={days}
                customTime={customTime}
                setCustomTime={setCustomTime}
                validate={validate}
                tabValue={tabValue}
                customTimeError={customTimeError}
                setCustomTimeError={setCustomTimeError}
              />
            </div>
          )}
          {tabValue === 2 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Contact</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.email}
                    handleInputChange={(e) => {
                      setFormData({ email: e });
                    }}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <MuiPhoneNumber
                    name='phone'
                    label='Phone Number'
                    data-cy='user-phone'
                    defaultCountry={countryCode || 'in'}
                    disableAreaCodes
                    autoFormat={true}
                    countryCodeEditable={false}
                    value={formData.phoneNumber.value}
                    className='col-md-12'
                    error={formData.phoneNumber.errors.required || false}
                    helperText={formData.phoneNumber.errors.required}
                    onChange={(phone, country) => handlePhoneNoChange(phone, country)}
                    sx={{ '& svg': { height: '1.2rem' } }}
                  />
                </div>
              </div>
              <h4 className='tab-title mt-3'>Information</h4>
              <ContactInformation
                informationTypes={CONTACT_INFO_TYPES}
                setContactInfoList={setContactInfoList}
                contactInfoList={contactInfoList}
                infoFieldKey='reviewerTitle'
                infoValueKey='URL'
              />
            </div>
          )}
          {tabValue === 3 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Location</h4>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <LocationInput onLocationSelect={onLocationSelect} />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.addressLine1}
                    handleInputChange={(e) => {
                      setFormData({ addressLine1: e });
                    }}
                    maxLength='150'
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.addressLine2}
                    handleInputChange={(e) => {
                      setFormData({ addressLine2: e });
                    }}
                    maxLength='150'
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.country}
                    handleInputChange={(e) => {
                      setFormData({ country: e });
                    }}
                    labelField='name'
                    valueField='name'
                    labelPrefix='Select'
                    options={Countries}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.state}
                    handleInputChange={(e) => {
                      setFormData({ state: e });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.postalCode}
                    handleInputChange={(e) => onChangePostalCode(e)}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.city}
                    handleInputChange={(e) => {
                      setFormData({ city: e });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.latitude}
                    handleInputChange={(e) => {
                      setFormData({ latitude: e });
                    }}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.longitude}
                    handleInputChange={(e) => {
                      setFormData({ longitude: e });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.area}
                    handleInputChange={(e) => {
                      setFormData({ area: e });
                    }}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.timeZone}
                    handleInputChange={(e) => {
                      setFormData({ timeZone: e });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                <div
                  className={`col-md-12 ${
                    !(formData.latitude && formData.longitude) ? 'disabled-container' : ''
                  }`}
                >
                  <LocationMap lat={formData.latitude.value} lng={formData.longitude.value} />
                </div>
              </div>
            </div>
          )}
          {tabValue === 4 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>CTA</h4>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby='demo-radio-buttons-group-label'
                  defaultValue={formData.status.value}
                  value={formData.status.value}
                  name='radio-buttons-group'
                  onChange={(e) => onCtaStatusChange(e)}
                >
                  <div className='menu-active-status'>
                    <FormControlLabel
                      value='Active'
                      control={<Radio className='radio' />}
                      label='Active'
                      className='me-5'
                    />
                  </div>

                  <FormControlLabel value='Inactive' control={<Radio />} label='Inactive' />
                </RadioGroup>
              </FormControl>
              {formData?.status.value === 'Active' && (
                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <CustomTextField
                      item={formData.ctaTabTitle}
                      handleInputChange={(e) => {
                        setFormData({ ctaTabTitle: e });
                      }}
                      maxLength={30}
                      endAdornment={true}
                      characterCount={true}
                    />
                  </div>
                  <div className='col-md-6 mb-3'>
                    <CustomSelect
                      item={formData.redirectOption}
                      handleInputChange={(e) => {
                        setFormData({ redirectOption: e });
                      }}
                      labelField='name'
                      valueField='value'
                      options={REDIRECT_OPTIONS}
                      hideNullOption={true}
                    />
                  </div>
                  {formData?.redirectOption.value === 'External URL' && (
                    <div className='col mb-3'>
                      <CustomTextField
                        item={formData.redirectUrl}
                        handleInputChange={(e) => {
                          setFormData({ redirectUrl: e });
                        }}
                        endAdornment={true}
                        characterCount={false}
                        multiline={true}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {tabValue === 5 && (
            <div className='col-md-12 mb-3'>
              <ImageUpload
                uploadedImages={formData.images.value}
                imgList={rawImages}
                onImageListUpdated={onImageListUpdated}
                onUploadedImageRemoval={onUploadedImageRemoval}
                onImagesLoading={(status) => {
                  setLoading(status);
                }}
                videoImageUrl={videoImageUrl}
                onVideoImageUrlChange={setVideoImageUrl}
                gifImageUrl={gifImageUrl}
                onGifImageUrlChange={setGifImageUrl}
                videoList={rawVideos}
                gifList={rawGifs}
                onVideoListUpdated={setRawVideos}
                onGifListUpdated={setRawGifs}
                hotelId={hotelId}
                groupId={groupId}
                propertyType={RESTAURANT_TYPES}
                onVideoError={setHasVideoError}
                onThumbnailUploading={setIsThumbnailUploading}
                onVideoLoading={setIsVideoLoading}
                onGifLoading={setIsGifLoading}
              />
            </div>
          )}
        </div>
        <FooterButton
          onNextClick={onNextClick}
          handleSubmit={handleSubmit}
          onCancel={onCancel}
          loading={loading}
          maxtab={5}
          tabValue={tabValue}
          isUpdate={restaurant?.id}
          isTabInValid={isTabInValid}
          hasVideoError={hasVideoError}
          isThumbnailUploading={isThumbnailUploading}
          isVideoLoading={isVideoLoading}
          isGifLoading={isGifLoading}
          isNextDisabled={isHoursTabWithoutTimings}
        />
      </div>
    </form>
  );
};

export default InfoCreate;
